// Code/src/Components/BankingAndSecureInfo/PayStub/PayStub.tsx
import React from "react";
import MyPayments from "./MyPayments";
import MyPayStubs from "./MyPayStubs";
import MyW2 from "./MyW2";

import { Button } from "../../ui/button";
import { useState } from "react";

type PayStubsProps = {
  user?: any; // Optional - will use from context if not provided
  userProfile?: any;
  staff?: any;
};

const PayStubs = (props: PayStubsProps) => {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = [
    { id: 0, label: "My Payments", icon: "tabler:clock" },
    { id: 1, label: "My Pay Stubs", icon: "uiw:pay" },
    { id: 2, label: "My W2", icon: "ion:receipt" },
  ];
  const tabContent = [
    <MyPayments key={0} />,
    <MyPayStubs key={1} />,
    <MyW2 key={2} />,
  ];
  return (
    <div>
      <h1 className="title">Pay Stubs</h1>
      <div className="tabContainer">
        <nav className="tabNav">
          {tabs.map((tab) => (
            <Button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              variant={activeTab === tab.id ? "default" : "ghost"}
              className={`tabButton ${activeTab === tab.id ? "activeTab" : "inactiveTab"}`}
            >
              {tab.label}
            </Button>
          ))}
        </nav>
      </div>
      <div className="contentContainer">{tabContent[activeTab]}</div>
    </div>
  );
};

export default PayStubs;
